// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".merchant-redirect-notification[data-v-f31dd9ea]{gap:22px}", ""]);
// Exports
module.exports = exports;
